module.exports = __webpack_public_path__ + "img/icon-seek-back.48e8865a.svg";